import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/fingerprint.vue
var s = {
	name: "DtIconFingerprint",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--fingerprint"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Fingerprint",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd"
	}, [...t[0] || (t[0] = [
		i("path", { d: "M6 1.5A4.515 4.515 0 0 0 1.5 6a.5.5 0 0 1-1 0C.5 2.974 2.974.5 6 .5a5.5 5.5 0 0 1 4.4 2.2.5.5 0 0 1-.8.6A4.5 4.5 0 0 0 6 1.5Z" }, null, -1),
		i("path", { d: "M3.335 4.528a.5.5 0 0 1 .307.637A2.521 2.521 0 0 0 3.5 6c0 1.54-.255 3.096-.526 3.908a.5.5 0 0 1-.948-.316C2.255 8.904 2.5 7.46 2.5 6c0-.408.07-.799.198-1.165a.5.5 0 0 1 .637-.307Zm5.608 3.974a.5.5 0 0 1 .45.546c-.038.389-.198 1.262-.258 1.56a.5.5 0 0 1-.98-.196c.06-.302.21-1.129.242-1.46a.5.5 0 0 1 .546-.45ZM4.94 4.94A1.5 1.5 0 0 1 6 4.5a.5.5 0 0 1 0 1 .5.5 0 0 0-.5.5c0 .535-.052 1.3-.133 2.053a.5.5 0 1 1-.994-.106A20.14 20.14 0 0 0 4.5 6c0-.398.158-.78.44-1.06Zm-.243 4.568a.5.5 0 0 1 .405.579 6.524 6.524 0 0 1-.245.892l-.056.173a.5.5 0 1 1-.952-.304l.067-.208c.086-.263.16-.49.202-.727a.5.5 0 0 1 .579-.405ZM7 6.06a.5.5 0 0 1 .5.5v.006c0 .593 0 1.406-.064 2.23-.064.82-.193 1.693-.472 2.39a.5.5 0 1 1-.928-.372c.221-.553.342-1.304.403-2.095A27.9 27.9 0 0 0 6.5 6.56a.5.5 0 0 1 .5-.5ZM.5 8a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 8Zm10.3-3.49a.5.5 0 0 1 .59.39c.025.124.04.326.051.54.011.226.019.505.021.802.004.592-.012 1.282-.064 1.808a.5.5 0 0 1-.995-.1c.047-.474.063-1.123.06-1.7a18.44 18.44 0 0 0-.02-.76 3.763 3.763 0 0 0-.033-.39.5.5 0 0 1 .39-.59Z" }, null, -1),
		i("path", { d: "M6 3.498a2.5 2.5 0 0 0-1.25.335.5.5 0 1 1-.5-.866A3.5 3.5 0 0 1 9.5 6H9h.5c0 .236 0 .591-.01 1.012a.5.5 0 0 1-1-.024c.01-.409.01-.753.01-.988A2.5 2.5 0 0 0 6 3.498Z" }, null, -1)
	])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=fingerprint.js.map